import { render, staticRenderFns } from "./SentencePreview.vue?vue&type=template&id=35032f15&"
import script from "./SentencePreview.vue?vue&type=script&lang=js&"
export * from "./SentencePreview.vue?vue&type=script&lang=js&"
import style0 from "./SentencePreview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports